import { render, staticRenderFns } from "./MyPageDetection.vue?vue&type=template&id=1f467959&scoped=true"
import script from "./MyPageDetection.vue?vue&type=script&lang=js"
export * from "./MyPageDetection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f467959",
  null
  
)

export default component.exports